var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 7.098
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD83C\\uDFA8-Color",
    d: "M6 2.162A2.468 2.468 0 113.532 4.63 2.468 2.468 0 016 2.162zm0 .925A1.543 1.543 0 107.543 4.63 1.543 1.543 0 006 3.088zM6-.001a6.172 6.172 0 015.986 4.667.464.464 0 11-.9.225 5.246 5.246 0 00-10.176 0 .464.464 0 01-.9-.224A6.172 6.172 0 016 0z"
  })));
}
export default SvgEyeWhite;